import React from 'react';
import {
  Accordion,
  InformationBanner,
  StackedColumn,
  StackedColumnSpacing,
} from '../../../../../core';
import {
  CernerSlot,
  DateTimeFilter,
  SlotDateGroup,
} from '../../../../../api/models';
import { ResultLocationGroups } from './resultLocationGroups';
import { DateUtility } from '@mchs/web-core';

export interface SearchResultsProps {
  searchResults: SlotDateGroup[];
  filter: DateTimeFilter;
  onSlotSelected: (
    appointmentDate?: Date,
    slot?: CernerSlot,
    locationId?: string,
    locationName?: string
  ) => void;
}

const SearchResults: React.FC<SearchResultsProps> = (
  props: SearchResultsProps
) => {
  return (
    <StackedColumn spacing={StackedColumnSpacing.NoGap}>
      {props.searchResults.length === 0 ? (
        <InformationBanner
          title="Select a new start date"
          text={`There are no appointments available from ${
            props.filter.date
              ? DateUtility.formatDateLongMonth(props.filter.date)
              : ''
          } - ${
            props.filter.thruDate
              ? DateUtility.formatDateLongMonth(props.filter.thruDate)
              : ''
          }`}
        />
      ) : (
        props.searchResults.map((slotDateGroup, index) => (
          // the wrapping div with negative margin is to prevent double horizontal
          // dividers between the result sets (really just overlaping them)
          <div key={`result${index}`} style={{ marginTop: '-1px' }}>
            <Accordion
              title={
                slotDateGroup.appointmentDate
                  ? DateUtility.formatDateLongWeekdayLongMonth(
                      slotDateGroup.appointmentDate
                    )
                  : ''
              }
              startExpanded={index === 0}
            >
              <ResultLocationGroups
                locationGroups={slotDateGroup.locationGroupList ?? []}
                onSlotSelected={(slot, locationId, locationName) =>
                  props.onSlotSelected(
                    slotDateGroup.appointmentDate,
                    slot,
                    locationId,
                    locationName
                  )
                }
              />
            </Accordion>
          </div>
        ))
      )}
    </StackedColumn>
  );
};

export default SearchResults;
